module.exports = __webpack_public_path__ + "img/service-express.3df606f.webp";